<template>
  <div class="content-box" v-if="current.id">
    <div class="row">
      <div class="col-sm7 col-lg-9 col-xxl-9">
        <router-link
          class="btn btn-sm btn-info"
          :to="{ name: 'cxp-cargo', params: {} }"
        >
          <i class="fas fa-angle-double-left"></i>
          Regresar
        </router-link>
        <div class="element-balances col-sm-12">
          <div class="balance balance-v2">
            <div class="balance-value sm-6">
              <span style="font-size: 70px"> Cargo # </span>
              <span style="font-size: 70px"> {{ current.numero }}</span>
            </div>
          </div>
          <!--START - Datos Proveedor Table-->
          <table class="table table-outset table-bordered table-v-compact mb-2">
            <tbody>
              <td colspan="3">
                <div class="balance-label smaller lighter text-nowrap">
                  <strong style="color: black">DATOS DE PROVEEDOR</strong>
                </div>
              </td>
              <tr>
                <td>
                  <div class="balance-label smaller lighter text-nowrap">
                    Código
                  </div>
                  <strong>{{ current.proveedor.codigo }}</strong>
                </td>
                <td colspan="3">
                  <div class="balance-label smaller lighter text-nowrap">
                    NIT
                  </div>
                  <strong>{{ current.proveedor.nit }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <div class="balance-label smaller lighter text-nowrap">
                    Nombre
                  </div>
                  <strong>{{ current.proveedor.nombre }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="balance-label smaller lighter text-nowrap">
                    Fecha Documento
                  </div>
                  <strong>{{
                    current.fecha_documento | moment("DD/MM/YYYY")
                  }}</strong>
                </td>
                <td>
                  <div class="balance-label smaller lighter text-nowrap">
                    Fecha Pago
                  </div>
                  <strong>{{
                    current.fecha_pago | moment("DD/MM/YYYY")
                  }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- END - Datos proveedor Table -->
          <!-- START - Tabla cargos -->
          <div class="balance-table pl-sm-1 col-sm-4">
            <div class="p-1 mb-6 col-sm-8">
              <div class="todo-list">
                <a class="todo-item dark" href="#">
                  <div class="verticalLine">
                    <div class="ti-header">Facturas:</div>
                    <div class="ti-sub-header">
                      <span style="font-size: 15px; color: black">
                        {{ current.numero }}
                      </span>
                      <span class="glyphicon glyphicon-duplicate"></span>
                    </div>
                  </div>
                </a>
                <a class="todo-item dark" href="#">
                  <div class="verticalLine">
                    <div class="ti-header">Monto Total:</div>
                    <div class="ti-sub-header">
                      <span style="font-size: 15px; color: black">
                        Q. {{ current.total }}
                      </span>
                      <span class="glyphicon glyphicon-duplicate"></span>
                    </div>
                  </div>
                </a>
                <a class="todo-item dark" href="#">
                  <div class="verticalLine">
                    <div class="ti-header">Referencia:</div>
                    <div class="ti-sub-header">
                      <span style="font-size: 15px; color: black">
                        {{ current.referencia }}
                      </span>
                      <span class="glyphicon glyphicon-duplicate"></span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <!-- END - Tabla cargos -->
        </div>
        <!-- START - Resumen Facturas Table-->
        <div class="element-wrapper">
          <h6 class="element-header">Resumen Facturas</h6>
          <div class="element-box-tp">
            <div class="table-responsive">
              <table class="table table-padded">
                <thead>
                  <tr>
                    <th style="width: 100px">SERIE</th>
                    <th>NÚMERO</th>
                    <th class="text-center">FECHA DOCUMENTO</th>
                    <th class="text-center">FECHA CONTABILIZACIÓN</th>
                    <th>TIPO</th>
                    <th class="text-right">MONTO</th>
                    <th class="text-right"></th>
                  </tr>
                </thead>
                <tbody
                  v-for="(detalle, index) in current.cargod_set"
                  :key="detalle.id"
                >
                  <tr
                    style="height: 10px"
                    @click="mostrarDetalle(index, detalle)"
                  >
                    <td
                      style="animation: fade-in 1.5s 1"
                      v-bind:style="
                        detalle_ == detalle
                          ? 'background-color: #B9D6A3;'
                          : 'background-color: white;'
                      "
                      class="text-left bolder nowrap"
                    >
                      <span class="text-dark" style="font-size: 85%">{{
                        detalle.serie
                      }}</span>
                    </td>
                    <td
                      style="animation: fade-in 1.5s 1"
                      v-bind:style="
                        detalle_ == detalle
                          ? 'background-color: #B9D6A3;'
                          : 'background-color: white;'
                      "
                      class="text-left bolder nowrap"
                    >
                      <span class="text-dark" style="font-size: 85%">{{
                        detalle.documento
                      }}</span>
                    </td>
                    <td
                      v-bind:style="
                        detalle_ == detalle
                          ? 'background-color: #B9D6A3;'
                          : 'background-color: white;'
                      "
                      style="width: 150px; animation: fade-in 1.5s 1"
                      class="text-center"
                    >
                      <span>{{ detalle.fecha_documento }}</span>
                    </td>
                    <td
                      v-bind:style="
                        detalle_ == detalle
                          ? 'background-color: #B9D6A3;'
                          : 'background-color: white;'
                      "
                      style="width: 200px; animation: fade-in 1.5s 1"
                      class="text-center"
                    >
                      <span
                        >{{
                          detalle.fecha_creacion | moment("DD/MM/YYYY HH:mm")
                        }}
                        Hrs.</span
                      >
                    </td>
                    <td
                      v-bind:style="
                        detalle_ == detalle
                          ? 'background-color: #B9D6A3;'
                          : 'background-color: white;'
                      "
                      style="width: 100px; animation: fade-in 1.5s 1"
                    >
                      <i class="fas fa-check"></i>
                      {{ detalle.bien_servicio_str }}
                      <br />
                      {{ detalle.local_importado_str }}
                    </td>
                    <td
                      v-bind:style="
                        detalle_ == detalle
                          ? 'background-color: #B9D6A3;'
                          : 'background-color: white;'
                      "
                      style="animation: fade-in 1.5s 1"
                      class="text-right bolder nowrap"
                    >
                      <span class="text-dark" style="font-size: 85%">
                        Q. {{ detalle.valor_total }}</span
                      >
                    </td>
                    <td
                      v-bind:style="
                        detalle_ == detalle
                          ? 'background-color: #B9D6A3;'
                          : 'background-color: white;'
                      "
                    >
                      <i
                        v-if="detalle_ == detalle"
                        class="fas fa-chevron-up"
                      ></i>
                      <i v-else class="fas fa-chevron-down"></i>
                    </td>
                  </tr>
                  <tr v-if="detalle_ == detalle">
                    <td colspan="7">
                      <table style="animation: fade-in 1.5s 1" class="table">
                        <thead>
                          <tr>
                            <th
                              class="text-center text-success"
                              style="width: 100px"
                            >
                              PRODUCTO
                            </th>
                            <th class="text-center text-success">CANTIDAD</th>
                            <th class="text-center text-success">PRECIO</th>
                            <th class="text-center text-success">
                              TOTAL LINEA
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="cargodproducto in detalle.cargodproducto_set"
                            :key="cargodproducto.id"
                            style="height: 10px"
                          >
                            <td class="text-center bolder nowrap">
                              <span class="text-dark" style="font-size: 85%">{{
                                cargodproducto.producto
                              }}</span>
                            </td>
                            <td class="text-center bolder nowrap">
                              <span class="text-dark" style="font-size: 85%">{{
                                cargodproducto.cantidad
                              }}</span>
                            </td>
                            <td class="text-center bolder nowrap">
                              <span class="text-dark" style="font-size: 85%">
                                Q. {{ cargodproducto.precio }}</span
                              >
                            </td>
                            <td class="text-center bolder nowrap">
                              <span class="text-dark" style="font-size: 85%">
                                Q {{ cargodproducto.total_linea }}</span
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3 col-lg-3 col-xxl-3">
        <!--------------------
            START - Sidebar
            -------------------->
        <div class="content-panel compact color-scheme-dark">
          <h6 class="element-header">Abonos Aplicados</h6>
          <div class="element-box-tp">
            <div class="post-box">
              <div class="post-content">
                <h6 class="post-title">Abono #</h6>
                <div class="post-text">
                  <table class="table">
                    <thead>
                      <th class="text-center">#</th>
                      <th class="text-center">Tipo</th>
                      <th class="text-center">Estado</th>
                      <th class="text-center">Aplicado</th>
                      <th class="text-center">Fecha</th>
                    </thead>
                    <tr
                      v-for="abono in current.aplicacionabonocargo_set"
                      v-bind:key="abono.id"
                    >
                      <td class="text-center">{{ abono.abono_e.documento }}</td>
                      <td class="text-center">
                        {{ abono.abono_e.tipo_abono }}
                      </td>
                      <td class="text-center">
                        {{ abono.abono_e.estado_str }}
                      </td>
                      <td class="text-center">
                        {{ abono.abono_e.total_aplicado }}
                      </td>
                      <td class="text-center">
                        {{ abono.abono_e.fecha_documento }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <!-------------------- END - Sidebar -------------------->
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import AbonoService from "@/services/cxp/AbonoService";
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import CargoAplicacionAbonoComponent from "@/components/cxp/cargo/CargoAplicacionAbonoComponent";
import CargoDComponent from "@/components/cxp/cargo/CargoDComponent";

export default {
  components: {
    ProveedoresSelectComponent,
    CargoAplicacionAbonoComponent,
    CargoDComponent,
  },
  data() {
    return {
      current: {
        id: null,
        bien_servicio_str: "B",
        local_importado_str: "L",
        total: null,
        total_aplicado: null,
        total_pendiente: null,
        cargod_set: [],
        aplicacionabonocargo_set: null,
        cargocontab_set: null,
        numero: null,
        fecha_creacion: null,
        fecha: null,
        referencia: null,
        fecha_documento: null,
        fecha_vencimiento: null,
        fecha_pago: null,
        fecha_iva: null,
        forma_pago: "CON",
        descripcion: null,
        factura_especial: null,
        estatus_contab: null,
        bien_servicio: null,
        local_importado: null,
        valor_total: null,
        valor_impuesto: null,
        estado: "A",
        tipo_cargo: "FACT",
        proveedor: null,
        errors: {
          id: null,
          estado_str: null,
          total_aplicado: null,
          total_pendiente: null,
          documento: null,
          fecha_creacion: null,
          fecha_documento: null,
          fecha_vencimiento: null,
          valor: null,
          descripcion: null,
          estatus_contab: null,
          conciliado: null,
          fecha_conciliacion: null,
          estado: null,
          beneficiario: null,
          es_negociable: null,
          tipo_abono: null,
          abono_serie: null,
          proveedor: null,
        },
      },
      errors: {
        id: null,
        estado_str: null,
        total_aplicado: null,
        total_pendiente: null,
        documento: null,
        fecha_creacion: null,
        fecha_documento: null,
        fecha_vencimiento: null,
        valor: null,
        descripcion: null,
        estatus_contab: null,
        conciliado: null,
        fecha_conciliacion: null,
        estado: null,
        beneficiario: null,
        es_negociable: null,
        tipo_abono: null,
        abono_serie: null,
        proveedor: null,
      },
      index_: null,
      abonoseries: [],
      tiposcargos: [],
      mostrar_cuadro: false,
      current_fact: {},
      detalle_: null,
    };
  },
  computed: {
    ...mapGetters({
      fecha_actual: "commons/fecha_actual",
      proveedor: "catalogos/proveedores",
    }),
  },
  mounted() {
    let self = this;
    if (self.$route.params.id) {
      self.refreshCurrent();
    } else {
      self.$store.dispatch("commons/fecha_actual").then((response) => {
        self.current.fecha_documento = self.fecha_actual;
        self.current.fecha_vencimiento = self.current.fecha_documento;

        self.current.fecha_documento = self.customFormatterInverted(
          self.current.fecha_documento
        );
        self.current.fecha_pago = self.customFormatterInverted(
          self.current.fecha_pago
        );
        self.current.fecha_vencimiento = self.customFormatterInverted(
          self.current.fecha_vencimiento
        );
      });
    }
    self.refreshCurrent();
    self.refreshTiposCargos();
    self.refreshProveedor();
  },
  methods: {
    mostrarDetalle(index, detalle) {
      let self = this;
      if (self.detalle_ == detalle) {
        self.detalle_ = null;
        return;
      }
      self.detalle_ = detalle;
    },
    customFormatterInverted(date) {
      if (date == null) {
        return "";
      }
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).add("days").format("YYYY-MM-DD");
    },
    refreshCurrent() {
      let self = this;
      if (this.$route.params.id) {
        DynamicService.getById("cxp", "cargos", this.$route.params.id).then(
          (response) => {
            self.current = Object.assign(self.current, response.data);

            self.current.proveedor = self.current.proveedor_obj;
            self.current.valor_temp = self.current.valor_total;
            self.current.fecha_documento = self.customFormatterInverted(
              self.current.fecha_documento
            );
            self.current.fecha_vencimiento = self.customFormatterInverted(
              self.current.fecha_vencimiento
            );
            self.current.fecha_conciliacion = self.customFormatterInverted(
              self.current.fecha_conciliacion
            );
            self.current.fecha_iva = self.customFormatterInverted(
              self.current.fecha_iva
            );
            self.current.fecha_pago = self.customFormatterInverted(
              self.current.fecha_pago
            );
          }
        );
      }
    },
    refreshTiposCargos() {
      let self = this;
      DynamicService.fetch("cxp", "tipo-cargo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.tiposcargos = res.data;
        if (self.tiposcargos.length != 0) {
          self.current.tipo_cargo = self.tiposcargos[0].id;
        }
      });
    },
    changeAbonoSerie() {
      let self = this;
      let obj = self.abonoseries.filter(function (elem) {
        if (elem.serie == self.current.abono_serie) return elem;
      });
      if (obj.length == 1) {
        self.current.abono_serie_obj = obj[0];
      }
      console.log(self.current.abono_serie_obj);
    },
    refreshProveedor() {
      let self = this;
      self.$store.dispatch("catalogos/proveedores", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    guardar(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.current);
      delete current.image;
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
      }
      current.proveedor = current.proveedor.codigo;
      if (current.id == null) {
        current.documento = 0;
      }
      if (current.fecha_documento) {
        current.fecha_documento = moment(current.fecha_documento).format(
          "DD/MM/YYYY"
        );
      }
      if (current.fecha_vencimiento) {
        current.fecha_vencimiento = moment(current.fecha_vencimiento).format(
          "DD/MM/YYYY"
        );
      }
      if (current.fecha_iva) {
        current.fecha_iva = moment(current.fecha_iva).format("DD/MM/YYYY");
      }
      if (current.fecha_conciliacion) {
        current.fecha_conciliacion = moment(current.fecha_conciliacion).format(
          "DD/MM/YYYY"
        );
      }
      if (current.fecha_pago) {
        current.fecha_pago = moment(current.fecha_pago).format("DD/MM/YYYY");
      }
      if (current.id == null) {
        delete current.id;
      }

      DynamicService.save("cxp", "cargos", current)
        .then((res) => {
          Notifications.alert.success(
            "CXP - Cargos",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cxp-cargo-editar",
            params: { id: res.data.id },
          });
          self.refreshCurrent();
        })
        .catch((error) => {
          console.log(error.response.data);
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
          });
        });
    },
    showModal(e) {
      e.preventDefault();
    },
    abrir() {
      let self = this;
      Notifications.alert
        .confirm(
          "Cargos",
          "Desea Abrir la transacción?",
          "Si Abrir",
          function () {
            DynamicService.postAction(
              "cxp",
              "cargos",
              self.current.id,
              "abrir"
            ).then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            });
          }
        )
        .catch((error) => {
          Notifications.alert.error(
            "Abrir Transaccion",
            error.response.data.detail
          );
        });
    },

    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          DynamicService.postAction("cxp", "cargos", self.current.id, "cerrar")
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Cargos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          AbonoService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Cargos",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
  },
};
</script>
